import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import HttpClient from "libs/utils/HttpClient";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  logo: {
    display: "flex",
    alignSelf: "center",
    width: 300,
    margin: theme.spacing(4),
  },
  title: {
    fontSize: 55,
    color: "#003b5c",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 50,
    backgroundColor: "#11cdef",
    alignSelf: "center",
  },
  offlineLogin: {
    alignSelf: "center",
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
}));

export default function RedirectConfirmPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [status_activate, setStatus_activate] = useState(false);

  const search = useLocation().search;
  const queryParams = queryString.parse(search);
  const id = encodeURIComponent(queryParams.UserID);

  const { isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.auth
  );

  const CheckAuthentication = async () => {
    const data = {
      userID: id,
    };

    try {
      const response = await HttpClient.post("/api/users/register/valid", data);

      if (response.results.check) {
        setStatus_activate(true);
        alert("Success Please Go to Login Page");
        history.push("/logout");
      } else {
        alert("ไม่สามารถดำเนินการได้");
        history.push("/logout");
      }

      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      setStatus_activate(false);
      const newError = error;
      // throw newError;
    }
  };

  useEffect(() => {
    if (id != null && id != undefined && id != "") {
      CheckAuthentication();
    }

    // console.log(query);
  }, []);

  return (
    <div className={classes.root}>
      <Container maxWidth="sm">
        <Card className={classes.paper}>
          <CardContent className={classes.content}>
            {/* <Typography variant="h4" className={classes.title}>
                Success
              </Typography> */}
            <Typography variant="h6">Smart VISA Service</Typography>
            <div className={classes.line} />
            <img
              alt="smart-visa"
              src="/assets/images/logo.png"
              className={classes.logo}
            />
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ marginBottom: 10 }}
            >
              <CircularProgress style={{ alignSelf: "center" }} />
            </Grid>

            <Button
              color="secondary"
              size="small"
              className={classes.offlineLogin}
              fullWidth={false}
              disabled={isLoading}
              //   onClick={handleClickOffline}
              href="/logout"
            >
              {status_activate
                ? " Success We taking you to Login Page."
                : "Something Went Wrong."}
            </Button>
          </CardContent>
        </Card>
      </Container>
    </div>
  );
}
